

import React from "react";

export const CalendarHeart = ({ className,state="defualt" }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M2 6.66668H14V4.00001C14 3.64639 13.8595 3.30725 13.6095 3.0572C13.3594 2.80715 13.0203 2.66668 12.6667 2.66668H3.33333C2.97971 2.66668 2.64057 2.80715 2.39052 3.0572C2.14048 3.30725 2 3.64639 2 4.00001V13.3333C2 13.687 2.14048 14.0261 2.39052 14.2762C2.64057 14.5262 2.97971 14.6667 3.33333 14.6667H8M5.33333 1.33334V4.00001M10.6667 1.33334V4.00001M14.1933 9.80001C13.9662 9.57396 13.6771 9.42037 13.3626 9.35867C13.0481 9.29696 12.7224 9.32991 12.4267 9.45334C12.2267 9.53334 12.0467 9.65334 11.8933 9.80668L11.6667 10.0333L11.4333 9.80668C11.2069 9.57951 10.9182 9.42467 10.6036 9.36177C10.2891 9.29887 9.96304 9.33074 9.66667 9.45334C9.46667 9.53334 9.29333 9.65334 9.14 9.80668C8.50667 10.4333 8.47333 11.4933 9.27333 12.3L11.6667 14.6667L14.0667 12.3C14.8667 11.4933 14.8267 10.4333 14.1933 9.80668V9.80001Z"
          stroke={state=="active"?"white":"black"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
    </svg>
  );
};
